import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { logger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { all, fork } from 'redux-saga/effects';

import { Server } from '../resources/Server';
import { blocksReducer, type IBlockState } from './reducers/blocks';
import envelopeReducer, { type IEnvelopeState } from './reducers/envelope';
import { groupsReducer, type IGroupState } from './reducers/groups';
import modalReducer, { type IModalState } from './reducers/modal';
import { signingExperienceReducer, type ISigningExperienceState } from './reducers/signingExperience';
import zoomReducer, { type IZoomState } from './reducers/zoom';
import signerSagas from './sagas';

function* rootSaga(server: any) {
  yield all([fork(signerSagas, server)]);
}

const rootReducer = combineReducers({
  zoom: zoomReducer,
  modal: modalReducer,
  envelope: envelopeReducer,
  blocks: blocksReducer,
  groups: groupsReducer,
  signingExperience: signingExperienceReducer,
});

export interface IRootState {
  zoom: IZoomState;
  modal: IModalState;
  envelope: IEnvelopeState;
  blocks: IBlockState;
  groups: IGroupState;
  signingExperience: ISigningExperienceState;
}

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default function configureStore(initialState = {}) {
  const sagaMiddleware = createSagaMiddleware();
  const middleware: any[] = [sagaMiddleware];
  if (process.env.NODE_ENV === 'development') {
    middleware.push(logger);
  }
  const enhancers = [applyMiddleware(...middleware)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;

  const store = createStore(rootReducer, initialState, composeEnhancers(...enhancers));

  sagaMiddleware.run(rootSaga, new Server());
  return store;
}
